@if (!loading) {
  <nz-page-header title="Потребителски профил"/>
  @if (profile.isActive) {
    <main class="container-lg">
      @if (!!profile.userBlockId) {
        <div class="mb-4 alert alert-danger">
          <i class="me-1 fas fa-exclamation-triangle" aria-hidden="true"></i>
          Блокиран потребител!
        </div>
      }
      <section class="mb-4 p-3 shadow border bg-white rounded-3">
        <div class="row g-3">
          <div class="col-12 col-sm-4 col-md-3 col-xxl-2 profile-image">
            <nz-image [imageUrl]="profileImageUrl"/>
          </div>
          <div class="col-12 col-sm-8 col-md-9 col-xxl-10">
            <div class="d-flex w-100 h-100 flex-wrap flex-column justify-content-between">
              <header class="d-none1 d-sm-block">
                <p class="lh-1 mb-2 text-break fs-4 fw-medium text-primary-emphasis"> {{ profile.username }}</p>
                <p class="mb-1 small fw-medium text-muted">
                  Последователи: {{ profile.followerCount }}
                </p>
                <p class="mb-1 small fw-medium text-muted">
                  <span>Потребителски рейтинг: </span>
                  <nz-user-rating [rating]="profile.userRating" [hiddenValue]="false"/>
                  <button
                    type="button"
                    aria-label="Научете повече"
                    (click)="showUserRatingInfo()"
                    class="ms-1 p-0 btn btn-link btn-sm text-primary-emphasis">
                    <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
                  </button>
                </p>
              </header>
              <div class="ms-auto mt-3 col-12 col-md-auto d-flex justify-content-end gap-3">
                <button
                  type="button"
                  [disabled]="loadingFollower"
                  class="btn btn-sm flex-grow-1"
                  [ngClass]="profile.userFollowerId ? 'btn-danger' : 'btn-nz-primary'"
                  (click)="upsertUserFollower()">
                  @if (loadingFollower) {
                    <span class="me-2 spinner-border spinner-border-sm"></span>
                  } @else {
                    <i class="me-2 fa-solid" aria-hidden="true"
                       [ngClass]="!!profile.userFollowerId ? 'fa-user-xmark' : 'fa-user-check'">
                    </i>
                  }
                  {{ !!profile.userFollowerId ? 'Спри да следваш' : 'Започни да следваш' }}
                </button>
                <div class="dropdown">
                  <a class="w-100 btn btn-sm btn-light border text-muted dropdown-toggle" href="#" role="button"
                     data-bs-toggle="dropdown"
                     aria-expanded="false">
                    Още
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end rounded-end-0 shadow">
                    <li>
                      <button class="dropdown-item" (click)="insertUserReport()">
                        <i class="dropdown-item-icon text-warning fas fa-exclamation-triangle" aria-hidden="true"></i>
                        Докладвай потребителя
                      </button>
                    </li>
                    <li>
                      <hr class="dropdown-divider">
                    </li>
                    <li>
                      @if (!profile.userBlockId) {
                        <button class="dropdown-item" (click)="showUserBlockWarning()">
                          <i class="me-2 text-danger fas fa-ban" aria-hidden="true"></i>
                          Блокирай потребителя
                        </button>
                      } @else {
                        <button class="dropdown-item" (click)="deleteUserBlock()">
                          <i class="me-2 text-success fas fa-user-check" aria-hidden="true"></i>
                          Деблокирай потребителя
                        </button>
                      }
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <i class="me-2 fa-solid fa-bullhorn" aria-hidden="true"></i>
          <h6 class="m-0">Обяви</h6>
        </header>
        <ul class="m-0 list-unstyled">
          <li class="table-hover-row">
            <div class="p-3 d-flex justify-content-between border-bottom">
              <span>Активни обяви:</span>
              <strong [ngClass]="profile.activeAdCount !== 0 ? 'text-dark' : 'text-secondary'">
                {{ profile.activeAdCount }}
              </strong>
            </div>
          </li>
          <li class="table-hover-row">
            <div class="p-3 d-flex justify-content-between border-bottom">
              <span>Неактивни обяви:</span>
              <strong [ngClass]="profile.inactiveAdCount !== 0 ? 'text-dark' : 'text-secondary'">
                {{ profile.inactiveAdCount }}
              </strong>
            </div>
          </li>
          <li class="table-hover-row">
            <div class="p-3 d-flex justify-content-between border-bottom">
              <span>Общо обяви:</span>
              <strong [ngClass]="profile.totalAdCount !== 0 ? 'text-dark' : 'text-secondary'">
                {{ profile.totalAdCount }}
              </strong>
            </div>
          </li>
        </ul>
        <footer class="bg-light p-3">
          <div class="d-flex justify-content-end">
            <div class="col-12 col-sm-5 col-md-4 col-lg-3 col-xl-2">
              <a class="w-100 btn btn-sm btn-nz-primary"
                 [routerLink]="[appRoutes.root, appRoutes.adList]"
                 [queryParams]="{sellerId: userId, sellerUsername: profile.username}">
                <i class="fa-solid fa-eye"></i>
                <span class="ms-2">Преглед на обявите</span>
              </a>
            </div>
          </div>
        </footer>
      </section>
      <section class="my-5">
        <h6 class="text-primary-emphasis">
          <i class="me-2 fa-solid fa-star" aria-hidden="true"></i>
          <span class="m-0">Последни отзиви</span>
        </h6>
        @if (profile.userFeedbacks.length === 0) {
          <h4 class="pt-4 text-center text-muted">
            Няма намерени отзиви
          </h4>
        }
        <ul class="list-unstyled" nzRestoreScrollPosition>
          @for (userFeedback of profile.userFeedbacks; track userFeedback.userFeedbackId) {
            <li class="my-3 border d-flex shadow bg-white rounded-3">
              <div class="rounded-start-1 profile-card-image bg-light d-flex align-items-center justify-content-center">
                <h5 class="m-0"
                    [ngClass]="userFeedback.percentage <= 25 ? 'text-danger' : userFeedback.percentage === 50 ? 'text-warning' : 'text-success'">
                  {{ userFeedback.percentage }}%
                </h5>
              </div>
              <div class="p-2 w-100">
                <p class="m-0 pb-1">
                  {{ userFeedback.comment }}
                </p>
                <div class="small text-muted">
                  Потребител:
                  <a class="text-decoration-none text-break"
                     [routerLink]="[appRoutes.root, appRoutes.profile, userFeedback.senderId]">
                    {{ userFeedback.senderUsername }}
                  </a>
                </div>
                <div class="small text-end text-muted">
                  {{ userFeedback.dateTime | date: 'dd:MM:yyyy г. HH:mm ч.' }}
                </div>
              </div>
            </li>
          }
        </ul>
      </section>
    </main>
  } @else {
    <section class="my-4 container-lg">
      <div class="alert alert-danger">
        <i class="me-2 text-danger fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
        <span>Профила е изтрит!</span>
      </div>
    </section>
  }
} @else {
  <nz-loader/>
}
